import React, { useEffect } from 'react';
import Header from './components/Header/Header';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AppRouter, { ROUTES } from './components/AppRouter/AppRouter';
import '/node_modules/flag-icons/css/flag-icons.min.css';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider, useDispatch } from 'react-redux';
import { persistor, store } from './redux/store';
import { Layout } from 'antd';
import './App.scss';
import GlobalLoader from './components/UI/GlobalLoader/GlobalLoader';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Footer from './components/Footer/Footer';
import ProductBanner from './components/UI/ProductBanner/ProductBanner';
import PaymentMethods from './components/PaymentMethods/PaymentMethods';
import RedirectToApp from './views/RedirectToApp/RedirectToApp';

i18next.use(initReactI18next).init({
  resources: {
    en: { translation: require('./locales/en.json') },
    lv: { translation: require('./locales/lv.json') }
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
    formatSeparator: '%',
    formatSeparatorSuffix: '%',
    format: function (value, format, lng) {
      if (format === 'uppercase') return value.toUpperCase();
      return value;
    }
  }
});

export const PersistorContext = React.createContext(null);

const MainLayout = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleBannerClose = () => {
      dispatch({ type: 'App/BANNER_CLOSE' });
    };

    document.addEventListener('scroll', handleBannerClose);

    const elementIds = ['header', 'footer', 'back-link', 'breadcrumbs', 'product-tabs'];

    elementIds.forEach(id => {
      const element = document.getElementById(id);
      if (element) {
        element.addEventListener('click', handleBannerClose);
      }
    });

    return () => {
      document.removeEventListener('scroll', handleBannerClose);
      elementIds.forEach(id => {
        const element = document.getElementById(id);
        if (element) {
          element.removeEventListener('click', handleBannerClose);
        }
      });
    };
  }, [dispatch]);

  return (
    <Layout style={{ width: '100%' }}>
      <Helmet>
        <title>{t('title')}</title>
        <meta property="og:title" content={t('title')} />
        <meta property="og:description" content={t('title')} />
        <meta property="description" content={t('title')} />
      </Helmet>
      <Header />
      <div style={{ minHeight: 'calc(100vh - 68px)', display: 'flex' }}>
        <AppRouter />
      </div>
      <GlobalLoader />
      <ProductBanner />
      <PaymentMethods />
      <Footer />
    </Layout>
  );
};

const AppContent = () => {
  return (
    <Routes>
      <Route path={ROUTES.APP_REDIRECT} element={<RedirectToApp />} />
      <Route path="/*" element={<MainLayout />} />
    </Routes>
  );
};

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <PersistorContext.Provider value={persistor}>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </PersistorContext.Provider>
      </PersistGate>
    </Provider>
  );
}

export default App;